import { useQuery } from '@tanstack/react-query'
import { httpClient } from './httpClient'

export const KEYS = {
  BLOGS: 'blogs',
}

export const getBlogs = async ({
  pageParam = 1,
  language = 'en',
  isTrending = undefined,
  search = '',
}) => {
  const response = await httpClient.get('/blogs', {
    params: {
      page: pageParam,
      language,
      limit: 10,
      ...(typeof isTrending !== 'undefined' ? { is_trending: isTrending } : {}),
      q: search,
    },
  })
  return response.data
}
export const useBlogs = (pageParam = 1, language = 'en', isTrending = undefined, search = '') =>
  useQuery(
    [
      KEYS.BLOGS,
      `page=${pageParam}`,
      `language=${language}`,
      `is_trending=${isTrending}`,
      `search=${search}`,
    ],
    async () => getBlogs({ pageParam, language, search, isTrending }),
    {
      keepPreviousData: true,
    }
  )
export const prefetchBlogs = (
  queryClient,
  pageParam = 1,
  language = 'en',
  isTrending = undefined,
  search = ''
) =>
  queryClient.prefetchQuery(
    [
      KEYS.BLOGS,
      `page=${pageParam}`,
      `language=${language}`,
      `is_trending=${isTrending}`,
      `search=${search}`,
    ],
    async () => getBlogs({ pageParam, language, search, isTrending })
  )

export const getBlogTopic = async (slug) => {
  const response = await httpClient.get(`/blogs/${slug}`)
  return response.data
}
export const prefetchBlogTopic = (queryClient, slug, language = 'en') =>
  queryClient.prefetchQuery([KEYS.BLOGS, `slug=${slug}`, `language=${language}`], async () =>
    getBlogTopic(slug, language)
  )
export const useBlogTopic = (slug, language = 'en') =>
  useQuery([KEYS.BLOGS, `slug=${slug}`, `language=${language}`], async () =>
    getBlogTopic(slug, language)
  )
